import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants';

import { zodPaginatedResponseSchema } from '@vestigas/data';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import { ACCOUNTING_REFERENCE_TYPES } from '../constants';

/**
 * Query params of the accounting-reference directory. `id` narrows to one
 * entry; `companyAccountId` scopes the directory to a single tenant.
 */
export const zodCostCentersAdminQueryParamsSchema = z
  .object({
    companyAccountId: z.uuid().optional(),
    id: z.uuid().optional(),
    isActive: z.boolean().optional(),
    limit: z
      .number()
      .int()
      .min(1)
      .max(500)
      .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
    offset: z.number().int().nonnegative().prefault(0),
    searchString: z.string().trim().optional(),
  })
  .transform((data) => withoutObjectKeysWhereValueIs(data, [undefined, '']));

/**
 * `VAdminAccountingReference` in the OpenAPI spec; every field but `id` is
 * nullable on the wire.
 */
export const zodCostCenterAdminSchema = z.object({
  companyAccountId: z.uuid().nullish(),
  companyId: z.uuid().nullish(),
  end: z.iso.datetime({ offset: true }).nullish(),
  id: z.uuid(),
  isActive: z.boolean().nullish(),
  name: z.string().nullish(),
  start: z.iso.datetime({ offset: true }).nullish(),
  syncKey: z.string().nullish(),
  // The API enforces this list in code over an unconstrained string column, so
  // an unexpected value degrades to `null` rather than failing the whole page.
  type: z.enum(ACCOUNTING_REFERENCE_TYPES).nullish().catch(null),
});

/** `PaginatedVAdminAccountingReferenceList` in the OpenAPI spec. */
export const zodCostCentersAdminResponseSchema = zodPaginatedResponseSchema(
  zodCostCenterAdminSchema,
);
